import { BUILDING_TYPE_LABELS } from 'shared/constants/buildingLabels';
import type { IBuildingCard } from 'shared/types/buildingCard';

import { getBuildingName } from './getBuildingName';

/** Тип здания в начале h1 — как `_building_type` SEO-презентера монолита */
function getTitleType(card: IBuildingCard): string | undefined {
  switch (card.type) {
    case 'businessCenter':
      return card.buildingType ? BUILDING_TYPE_LABELS[card.buildingType] : undefined;
    case 'warehouse':
      return 'СК';
    case 'shoppingCenter':
      return card.buildingType === 'shoppingAndEntertainmentCenter' ? 'ТРЦ' : 'ТЦ';
    default:
      return undefined;
  }
}

/** h1 карточки — как `BusinessShoppingCenterSeoPresenter.h1` монолита */
export function getBuildingTitle(card: IBuildingCard): string {
  const name = getBuildingName(card);
  const type = getTitleType(card);

  return type ? `${type} ${name}` : name;
}
